export enum SupportTicketSnoozeDuration {
  _1h = "1h",
  _4h = "4h",
  _24h = "24h",
}
